<template>
  <div class="case-order-bd tb" v-if="funcView.case_order_list">
    <custom-tab
      :list="tabData"
      v-model="tabIndex"
    ></custom-tab>
    <div
      class="tab-content"
      :key="updateKey"
    >
      <case-order-wait v-if="tabIndex === 0"></case-order-wait>
      <case-order-processing v-if="tabIndex === 1"></case-order-processing>
      <case-order-finish v-if="tabIndex === 2"></case-order-finish>
      <case-order-unresolved v-if="tabIndex === 3"></case-order-unresolved>
    </div>
  </div>
</template>

<script>
/** 案例订单 */
import caseOrderWait from './children/case_order_wait';
import caseOrderProcessing from './children/case_order_processing';
import caseOrderFinish from './children/case_order_finish';
import caseOrderUnresolved from './children/case_order_unresolved';

export default {
  components: { caseOrderWait, caseOrderProcessing, caseOrderFinish, caseOrderUnresolved },
  name: 'caseOrder',
  data() {
    return {
      provide: true,
      formSearch: {
        productCode: '',
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 20,
        pageNum: 1,
      },
      tabIndex: 0,

      tableList: [],
      totalRows: null,
      updateKey: 1,
      // 用于记录更新的stack
      records: [],
    };
  },
  computed: {
    tabData() {
      return [
        {
          name: this.$t('asm_case_order.dai_shou_li'),
          value: 0,
        },
        {
          name: this.$t('asm_case_order.chu_li_zhong'),
          value: 1,
        },
        {
          name: this.$t('asm_case_order.yi_chu_li'),
          value: 2,
        },
        {
          name: this.$t('asm_case_order.wei_jie_jue'),
          value: 3,
        },
      ];
    }
  },
  mounted: function () {
    this.getFuncView();
    this.Bus.$on('caseOrderChange', this.onUpdateRecord);
  },
  methods: {
    updateList() {
      this.updateKey++;
    },
    onUpdateRecord() {
      this.records.push(1);
    },
  },
  activated() {
    // 工单详情更新后，列表应进行更新
    if (this.records.length) {
      this.records = [];
      this.updateList();
    }
  }
};
</script>

<style lang='scss' scoped>
.case-order-bd {
  padding: 0 !important;
  display: flex;
  flex-direction: column;

  .tab-content {
    flex: 1;
    overflow: hidden;
  }
}
</style>
